/* apps/viewer/src/app/settings-form/settings-form.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
:host .header {
  box-sizing: border-box;
  color: #fafafa;
  display: flex;
  height: 60px;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}
:host mat-form-field {
  width: 120px;
}
:host .icon {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 60px;
  justify-content: center;
  transition: all ease 0.3s;
  width: 60px;
}
:host .icon ::ng-deep svg {
  fill: #fafafa;
  height: 30px;
  transition: all ease 0.3s;
  width: 30px;
}
:host .icon:hover,
:host .icon:focus {
  transition: all ease 0.3s;
}
:host .icon:hover ::ng-deep svg,
:host .icon:focus ::ng-deep svg {
  fill: #fafafa;
  transition: all ease 0.3s;
}
:host .set-item {
  align-items: center;
  border-bottom: 1px solid #eee !important;
  display: flex;
  height: 90px;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 24px;
}
::ng-deep .settings-dialog-container {
  max-width: 100vw !important;
}
::ng-deep .settings-dialog-container .mat-mdc-dialog-content {
  height: 73vh;
  max-height: 100vh;
  padding: 0;
  width: 60vw;
}
@media only screen and (max-width: 1024px) {
  ::ng-deep .settings-dialog-container .mat-mdc-dialog-content {
    height: 100vh;
    width: 100vw;
  }
}
@media only screen and (max-height: 400px) {
  ::ng-deep .settings-dialog-container .mat-mdc-dialog-content {
    height: 100vh;
    width: 100vw;
  }
}
/*# sourceMappingURL=settings-form.component.css.map */
